module.exports = "<div class=\"igx-control\">\n    <input class=\"igx-control__radio\" type=\"radio\" #radio\n        [attr.id]=\"id\"\n        [attr.name]=\"name\"\n        [attr.value]=\"value\"\n        [attr.tabindex]=\"tabindex\"\n        [attr.aria-checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [checked]=\"checked\"\n        (change)=\"onChange($event)\"\n        (focus)=\"onFocus($event)\"\n        (blur)=\"onBlur($event)\"/>\n    <label class =\"igx-control__label\" [attr.for]=\"id\"><ng-content></ng-content></label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/radio/radio.component.html
// module id = 103
// module chunks = 0 1